import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyTenantDocumentBranding } from "./documentBranding";

const TenantDocumentBranding = ({ tenant }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    applyTenantDocumentBranding(tenant);
  }, [
    location.key,
    location.pathname,
    location.search,
    tenant.cssName,
    tenant.favicon,
    tenant.faviconVersion,
    tenant.logo,
    tenant.title,
  ]);

  return null;
};

export default TenantDocumentBranding;
